import { SvgIcon } from '@avantia/style-guide';
import type { HpSvgIconTypes } from '@avantia/style-guide';
import { useContext } from 'react';
import { useAccordionButton, AccordionContext, Card } from 'react-bootstrap';

import './accordionToggle.scss';

interface AccordionToggleProps {
  eventKey: string;
  callback?: (eventKey: string) => void;
  setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AccordionToggle = ({ eventKey, callback, setIsDisabled }: AccordionToggleProps) => {
  const { activeEventKey } = useContext(AccordionContext);

  const isCurrentEventKey = activeEventKey === eventKey;

  const decoratedOnClick = useAccordionButton(eventKey, () => {
    isCurrentEventKey && setIsDisabled(false);
    callback && callback(eventKey);
  });

  return (
    <Card.Header
      onClick={decoratedOnClick}
      id="accordion-toggle"
      className={isCurrentEventKey ? 'toggle-open' : 'toggle-closed'}>
      <p className="email-text av-text-large">Email my documents</p>
      <SvgIcon
        type={(isCurrentEventKey ? 'angle-up' : 'angle-down') as HpSvgIconTypes}
        size="semi-tiny"
        data-testid="accordion-icon"
      />
    </Card.Header>
  );
};
